import React from 'react'
import SocialLinks from '../UI/SocialLinks/SocialLinks';
import classes from './Footer.module.scss';

const Footer = () => {
    return (
        <div className={classes.Footer}>
            <div className={[classes.Container, 'container'].join(' ')}>

                <div className={[classes.Contents, classes.Left].join(' ')}>
                    <h3 className={classes.Title}>Azher U.</h3>

                    <SocialLinks className={classes.Socials} />
                </div>

                <div className={[classes.Contents, classes.Right].join(' ')}>
                    <p className={classes.Text}>&copy; 2021 Azher U. All right reserved.</p>
                </div>

            </div>
        </div>
    )
}

export default Footer
